import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpClient,
} from "@angular/common/http";
import {
  catchError,
  forkJoin,
  map,
  Observable,
  switchMap,
  throwError,
} from "rxjs";
import { AuthService } from "app/core/auth/auth.service";
import { AuthUtils } from "app/core/auth/auth.utils";
import { NavigationService } from "@core/navigation/navigation.service";
import { environment } from "environments/environment";
import { AuthRoute } from "./guards/authRoute";

import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    private navigation: NavigationService,
    private _httpClient: HttpClient,
    private routes: AuthRoute,
    private urlUser: Location,
    private _router: Router,
  ) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // if (req.method === 'GET' && !req.headers.has('Authorization')) {
    //     // La solicitud es un GET y no tiene el encabezado personalizado que desea agregar
    //     // No necesitamos enviar una solicitud OPTIONS previa
    //     return next.handle(req);
    // }

    let newReq = req.clone();

    if (
      this._authService.accessToken &&
      !AuthUtils.isTokenExpired(this._authService.accessToken)
    ) {
      if (req.url.includes("indicadores.tech-test.com.ar")) {
        return next.handle(req);
      }

      // req.headers.set('Access-Control-Allow-Headers','*')
      // req.headers.set('tuki','sads')
      // req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
      // let headers  = new HttpHeaders ()
      // headers.append('Authorization','Bearer ' + this._authService.accessToken)
      newReq = req.clone({
        headers: req.headers.set(
          "tokeninpro",
          "Bearer " + this._authService.accessToken,
        ),
      });
    }

    if (this.navigation.flag && this.routes.requestValid(req.url)) {
      let id_modulo;

      id_modulo = this.routes.getIdModulo(
        this.navigation.navigationData,
        this.urlUser.path(),
      );

      if (id_modulo) {
        newReq = newReq.clone({
          headers: newReq.headers.set("Sub-Module", id_modulo + ""),
        });
      } else {
        // this._router.navigateByUrl('/home')
      }
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Sign out
          this._authService.signOut();

          // Reload the app
          location.reload();
        }

        if (
          (error instanceof HttpErrorResponse && error.status === 403) ||
          error.status
        ) {
          // Sign out
          // if (error.error.code == '1') {
          //     this._router.navigateByUrl('/home')
          // }
          // if (error.error.code == '0') {
          //     this._router.navigateByUrl('/home')
          // }
          // Reload the app
        }

        if (error instanceof HttpErrorResponse && error.status === 500) {
          // Sign out
          // this._authService.signOut();
          // // Reload the app
          // location.reload();
        }

        return throwError(error);
      }),
    );
  }
}
